export const optionsProfessions = [
  "Estudante",
  "Empregado",
  "Autônomo",
  "Desempregado",
  "Aposentado",
  "Outros",
];
